import { useEffect, useState } from "react"
import { DeliveryDataForm } from "./deliveryDataForm"
import { useRoutesHooks } from "../../../../../features/routes"
import { TableName } from "../../../../../tables"
import { Customer, SaleOperation, useCustomerLoaders } from "../../../../sales"
import { PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { Operation, operationHelpers } from "../../../../operations"

export const DeliveryDataFormLoader = () => {
    const { tableName, dataType } = useRoutesHooks().parseUrl()
    const isSaleOperation = [TableName.SALE_ORDERS, TableName.HOARD_ORDERS].includes(tableName!)
    const operation = dataType! as Operation

    const [ready, setReady] = useState(false)
    const [customer, setCustomer] = useState<Customer>()
    
    const { describeCode, describeNoun, getRoutePath } = operationHelpers

    const customerLoaders = useCustomerLoaders()

    const { setDisableBranchSelector } = useUIStateActions()

    const load = async () => {
        if (isSaleOperation) {
            const saleOperation = operation as SaleOperation
            const { loadCustomer } = customerLoaders()
            const loadedCustomer = await loadCustomer(saleOperation.customerId)
            setCustomer(loadedCustomer)
        }
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const crumbs = useGetCrumbs(
        describeNoun(tableName!, true),
        getRoutePath(tableName!),
        describeCode(operation),
        operation.id,
        'Editar Datos de Entrega'
    )

    return (
        <PanelLoader
            title="Editar Datos de Entrega"
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <DeliveryDataForm
                table={tableName!}
                operation={operation}
                customer={customer!}
            />
        </PanelLoader>
    )
}
